<template>
  <v-dialog v-model="dialog" persistent :max-width="600">
    <v-card>
      <v-card-title>
        <h3 class="mb-0">Pay Solutions Payment</h3>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('detail') }"
              xs12
              sm12
              md12
            >
              <label
                ><b>{{ $t('Detail') }}</b></label
              >
              <input
                v-validate="'max:250|required'"
                name="detail"
                v-model="input.detail"
                type="text"
              />
              <!-- data-vv-as="Image" -->
              <span class="text-error" v-show="errors.has('detail')"
                >{{ errors.first('detail') }}
              </span> </v-flex
            ><br />
            <v-flex class="form-control" :class="{ 'has-error': errors.has('amount') }" xs12>
              <label
                ><b>{{ $t('Amount') }}</b></label
              >
              <div class="d-flex">
                <input name="amount" v-model="input.value" type="text" ref="valueText" />
                <v-menu offset-y open-on-hover>
                  <template v-slot:activator="{ on }">
                    <v-btn fab small outline v-on="on" class="ml-1 extra-small" color="primary">
                      <span class="fas fa-ellipsis-v"></span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in prefills"
                      :key="index"
                      @click="addPrefill(item)"
                    >
                      <v-list-tile-title class="primary-color">{{ item.label }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
              <span class="text-error" v-show="errors.has('amount')"
                >{{ errors.first('amount') }}
              </span>
            </v-flex>
            <!-- <v-flex class="form-control" xs6 sm6 md6>
              <label
                ><b>{{ $t('Delivery Method') }}</b></label
              >
              <multiselect
                v-model="input.delivery"
                :show-labels="false"
                track-by="name"
                label="name"
                placeholder="Select one"
                :options="deliveryMethods"
                :searchable="false"
                :allow-empty="false"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  ><strong>{{ option.name }}</strong></template
                >
              </multiselect>
            </v-flex> -->
            <v-flex
              class="form-control"
              :class="{ 'has-error': errors.has('message') }"
              xs12
              sm12
              md12
            >
              <label
                ><b>{{ $t('Response Message') }}</b></label
              >
              <AutoresizeTextarea
                v-validate="'max:500|required'"
                v-model="input.text"
                style="white-space: break-spaces"
                name="message"
              />
              <span class="text-error" v-show="errors.has('message')"
                >{{ errors.first('message') }}
              </span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outline color="grey" flat @click="close">Close</v-btn>
        <v-btn v-if="input.create" depressed color="primary" @click="save">Save</v-btn>
        <v-btn v-else depressed color="primary" @click="update">Update</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'

export default {
  components: { Multiselect, AutoresizeTextarea },
  props: ['value', 'paysolutionValue'],
  data() {
    return {
      dialog: this.value,
      deliveryMethods: [
        { name: '', code: 0 },
        { name: 'Thailandpost (Normal)', code: 1 },
        { name: 'Thailandpost (Registrated Mail)', code: 2 },
        { name: 'Thailandpost (EMS)', code: 3 },
        { name: 'Kerry Express', code: 4 },
        { name: 'Grab', code: 5 },
        { name: 'Uber', code: 6 },
        { name: 'Skootar', code: 7 },
        { name: 'Lalamove', code: 8 },
        { name: 'Lineman', code: 9 },
        { name: 'SCG', code: 10 },
        { name: 'Nim express', code: 11 },
        { name: 'Other', code: 12 },
        { name: 'Flash Express', code: 13 },
        { name: 'Alpha Fast', code: 14 }
      ]
    }
  },
  computed: {
    input() {
      return this.paysolutionValue
    },
    prefills() {
      return [{ label: this.$t('Number'), value: 'number' }]
    }
  },
  methods: {
    save() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          this.goToErrorInput()
          return false
        }

        this.$emit('addIntentItem', 'pay_solutions_link', this.input)
        this.close()
      })
    },
    update() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          reject()
          return false
        }
        this.$emit('updatePaymentItem', this.input)
        this.close()
      })
    },
    close() {
      this.dialog = false
      this.$emit('input', false)
    },
    addPrefill(item) {
      const input = this.$refs.valueText
      const inputText = `{${item.value}}`
      if (!input) return
      let text = this.input.value
      if (input.selectionEnd > input.selectionStart) {
        const textStart = input.selectionStart > 0 ? text.slice(0, input.selectionStart) : ''
        const textEnd = text.slice(input.selectionEnd)
        text = [ textStart, inputText, textEnd ].join('')
      } else if (!text){
        text = inputText
      } else {
        text = [
          text.slice(0, input.selectionStart),
          inputText,
          text.slice(input.selectionStart)
        ].join('')
      }

      this.$nextTick(() => {
        this.input.value = text
        this.$refs.valueText.focus()
        this.$refs.valueText.selectionEnd = text.length
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPaySolution.vue